var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37232 7.9346H1.5V6.83772H3.53304L3.79621 5.16429H1.80134V4.06741H3.95491L4.39286 1.5H5.67656L5.23862 4.0654H7.36004L7.79799 1.5H9.06563L8.62768 4.0654H10.5V5.16228H8.4529L8.2058 6.83571H10.1987V7.93259H8.05915L7.60714 10.5H6.33951L6.77746 7.9346H4.63996L4.20201 10.5H2.93438L3.37232 7.9346ZM5.06384 5.16228L4.81473 6.83772H6.93616L7.18326 5.16429H5.06384V5.16228Z",
    fill: "#3F8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.22c5d4a914fc0eebc22fc0c933c72a8b.svg";
export { ForwardRef as ReactComponent };